import { apiRequest } from "../utils/apiClient";

/* =========================================================
   GET ALL PERMISSIONS
========================================================= */

export const fetchAllPermissions = async () => {
  const response = await apiRequest("/api/permissions", "GET");

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response.data;
};

/* =========================================================
   GET ROLE PERMISSIONS
========================================================= */

export const fetchRolePermissions = async (roleId: string) => {
  const response = await apiRequest(`/api/permissions/role/${roleId}`, "GET");

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response.data;
};

/* =========================================================
   UPDATE ROLE PERMISSIONS
========================================================= */

export const updateRolePermissions = async (
  roleId: string,
  permissionIds: string[],
) => {
  const response = await apiRequest(`/api/permissions/role/${roleId}`, "PUT", {
    permissionIds,
  });

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response.data;
};

/* =========================================================
   GET USER PERMISSIONS
========================================================= */

export const fetchUserPermissions = async (userId: string) => {
  const response = await apiRequest(`/api/permissions/user/${userId}`, "GET");

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response.data;
};

/* =========================================================
   UPDATE USER PERMISSIONS
========================================================= */

export const updateUserPermissions = async (
  userId: string,
  permissions: {
    permission_id: string;
    allowed: boolean | null;
  }[],
) => {
  const response = await apiRequest(`/api/permissions/user/${userId}`, "PUT", {
    permissions,
  });

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response.data;
};
